<div class="image">
  <img [src]="logoSrc" alt="Bosch logo" />
</div>
